import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";
import { useState } from "react";
import { useEffect } from "react";
import Select from "react-select";
import KeepingplantsAdd from "../KeepingplantsAdd/KeepingplantsAdd";
import { CommanPlantionDetailsPartTwoDDL } from "../../../../CommonDDL/CommanPlantionDetailsPartTwoDDL";
import { CommanPlantionDetailsDDLAPI } from "../../../../../Helper/Redux/DDLSlice/DDLSlice";
import { DeadSamplingsDeleteAPI, PlantationDetailsPartTwoPostAPI, PlantationDetailsPartTwoTableDataAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartTwoSlice";
import ReplacedDeadSamplingsPopUp from "./ReplacedDeadSamplingsPopUp";
import KeepingPlantsAtHome from "./KeepingPlantsAtHome";
import { Loading } from "../../../../../Helper/LogoLoader/LogoLoader";
import DeletePopUP from "../../../../CommonPopUp/DeletePopUp";
import { CommonCircle } from "../CommonCircle";
import { AstricSign } from "../../../../../Helper/AstricSign";

const PartSecondPopup = (props) => {

    const { handleShowAddModal, handleIsPost, ShowAddModal, FinancialYearID, MonthsID, YearValue, MonthValue, Title } = props
    const { flag, data } = ShowAddModal

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [RadioPlantwere, setRadioPlantwere] = useState('')
    const [SaplingSchemeIndicatorID, setSaplingSchemeIndicatorID] = useState('')
    const [CasualtyReplacementIndicatorID, setCasualtyReplacementIndicatorID] = useState('')
    const [Radiodeadsamplings, setRadiodeadsamplings] = useState('')
    const [Radiocoverlosses, setRadiocoverlosses] = useState('No')
    const [RadioKeepingplants, setRadioKeepingplants] = useState('')
    const [ReasonForDeath, setReasonForDeath] = useState([])
    const [PlantationDetails, setPlantationDetails] = useState([])
    const [ReplacedDeadSampling, setReplacedDeadSampling] = useState([])
    const [KeepingQualityHomeData, setKeepingQualityHomeData] = useState([])
    const [DataIsPost, setDataIsPost] = useState(false)
    const [PlantSupplied, setPlantSupplied] = useState('')

    const [OneStep, setOneStep] = useState('')
    const [TwoStep, setTwoStep] = useState('')
    const [ThreeStep, setThreeStep] = useState('')
    const [DeathData, setDeathData] = useState([])
    const [ReasonForDeathID, setReasonForDeathID] = useState([])
    const [IsReplacedDeadSamplingData, setIsReplacedDeadSamplingData] = useState(false)

    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })
    const [ReplacedDeadSamplingsId, setReplacedDeadSamplingsId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [QualityStatusId, setQualityStatusId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ShowDeadSamplingModal, setShowDeadSamplingModal] = useState({
        showHide: false,
        flag: '',
        data: ''
    })

    const handleShowDeadSamplingModal = (show, flag, data) => {
        setShowDeadSamplingModal({
            showHide: show,
            flag: flag,
            data: data
        })
    }
    const handleShowDelete = (data) => {
        setShowDeletePopup(!ShowDeletePopup)
        { data && setShowDeletePopupData(data) }
    }

    const handleIsReplacedDeadSamplingData = () => {
        setIsReplacedDeadSamplingData(!IsReplacedDeadSamplingData)
        handleShowDeadSamplingModal(false, '')
        setShowDeletePopup(false)
    }

    useEffect(() => {
        setRadioPlantwere(PlantationDetails && PlantationDetails[0]?.suppliedAtRightTime_M_IndicatorID)
        setPlantSupplied(flag == 'Update' ? PlantationDetails && PlantationDetails[0]?.suppliedAtRightTime : '')
        setSaplingSchemeIndicatorID(PlantationDetails && PlantationDetails[0]?.saplingScheme_M_IndicatorID)
        setCasualtyReplacementIndicatorID(PlantationDetails && PlantationDetails[0]?.casualtyReplacement_M_IndicatorID)
        setRadiodeadsamplings(PlantationDetails && PlantationDetails[0]?.replacedDeadSapling_M_IndicatorID)
        setRadioKeepingplants(PlantationDetails && PlantationDetails[0]?.keepingPlantsathome_M_IndicatorID)
        setOneStep(flag == 'Update' ? PlantationDetails && PlantationDetails[0]?.qualityOfPlantationl_One : '')
        setTwoStep(flag == 'Update' ? PlantationDetails && PlantationDetails[0]?.qualityOfPlantationl_Two : '')
        setThreeStep(flag == 'Update' ? PlantationDetails && PlantationDetails[0]?.qualityOfPlantationl_Three : '')
    }, [PlantationDetails])

    // useEffect(() => {
    //     const data = {
    //         UserID: UserID,
    //         token: token,
    //         Flag: 'ReasonForDeath',
    //         M_TableUserMasterID: UserID,
    //         setReasonForDeath: setReasonForDeath,
    //     }
    //     dispatch(CommanPlantionDetailsDDLAPI({ data }))
    // }, [])

    // const { DDLData } = useSelector(state => state.CommanPlantionDetailsDDLData)

    useEffect(() => {
        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "PlantationPart2",
            token: token,
            setPlantationDetails: setPlantationDetails,
        }
        if (YearValue && MonthValue) {
            dispatch(PlantationDetailsPartTwoTableDataAPI({ data }))
        }


    }, [YearValue, MonthValue])

    useEffect(() => {
        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "ReplacedDeadSapling",
            token: token,
            setReplacedDeadSampling: setReplacedDeadSampling,
        }
        if (YearValue && MonthValue) {
            dispatch(PlantationDetailsPartTwoTableDataAPI({ data }))
        }

    }, [IsReplacedDeadSamplingData, YearValue, MonthValue])

    useEffect(() => {

        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "KeepingPlanAtHome",
            token: token,
            setKeepingQualityHomeData: setKeepingQualityHomeData,
        }
        if (YearValue && MonthValue) {
            dispatch(PlantationDetailsPartTwoTableDataAPI({ data }))
        }

    }, [DataIsPost, YearValue, MonthValue])

    useEffect(() => {
        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "ReasonForDeath",
            token: token,
            setReasonForDeath: setReasonForDeath,
            handleSetData: handleSetData,
        }
        if (YearValue && MonthValue) {
            dispatch(PlantationDetailsPartTwoTableDataAPI({ data }))
        }

    }, [YearValue, MonthValue])

    const { isLoading } = useSelector(state => state.PlantationDetailsPartTwoTableData)


    var allCheckData = ""

    const handleSetData = (Data) => {
        let roleData = Data?.map((item) => ({ ...item, isChecked: item.isCheck == 1 ? true : false, }))

        setDeathData(roleData)
        roleData && roleData.forEach((item) => {
            if (item.isChecked) {
                allCheckData = allCheckData + item.reasonForDeathM_IndicatorID + ","
            }
        })
        setReasonForDeathID(allCheckData)
        // console.log('allCheckData', allCheckData)
    }


    const handleRadioValueChange = (check, index) => {
        if (DeathData) {
            let tempGridData = [...DeathData]
            tempGridData[index].isChecked = !(tempGridData[index].isChecked)
            setDeathData(tempGridData)
        }

        let allCheckData = ""
        DeathData.forEach((item) => {
            if (item.isChecked) {
                allCheckData = allCheckData + item.reasonForDeathM_IndicatorID + ","
            }

            setReasonForDeathID(allCheckData)
        })

    }
    // console.log("ShowAddModal.data.t_BeneficiaryPlantationDetailsID",PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID)
    const handleUpdate = () => {

        const data = {

            // T_BeneficiaryPlantationDetailsID: ShowAddModal.data.t_BeneficiaryPlantationDetailsID,
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            T_BeneficiaryPlantationDetailsID: PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetails && PlantationDetails[0]?.t_BeneficiaryPlantationDetailsID : 0,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            SuppliedAtRightTime_M_IndicatorID: RadioPlantwere,
            SuppliedAtRightTime: PlantSupplied,
            SaplingScheme_M_IndicatorID: SaplingSchemeIndicatorID,
            CasualtyReplacement_M_IndicatorID: CasualtyReplacementIndicatorID,
            ReplacedDeadSapling_M_IndicatorID: Radiodeadsamplings,
            ReasonForDeath_M_IndicatorID: 0,
            ReasonForDeath: ReasonForDeathID,
            KeepingPlantsathome_M_IndicatorID: RadioKeepingplants,
            QualityOfPlantationl_M_IndicatorID: QualityStatusId.ID,
            QualityOfPlantationl_One: OneStep,
            QualityOfPlantationl_Two: TwoStep,
            QualityOfPlantationl_Three: ThreeStep,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsPost
        }
        dispatch(PlantationDetailsPartTwoPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.PlantationDetailsPartTwoPostData)

    const handleDeleteData = () => {

        const data = {
            T_BeneficiaryPlantationDetails_ReplacedDeadSaplingID: ShowDeletePopupData?.t_BeneficiaryPlantationDetails_ReplacedDeadSaplingID,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsReplacedDeadSamplingData
        }
        dispatch(DeadSamplingsDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.DeadSamplingsDeleteData)

    return (
        <>
            {isLoading ? <Loading /> :
                <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
                    <div className="modal-dialog modal-lg " style={{ minWidth: '40vw' }} role="document"  >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold text-danger modal-title-fs" id="exampleModalLongTitle">{Title}</h5>
                                <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" style={{ marginLeft: "auto" }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ overflowY: 'scroll', height: '80vh' }}>
                                <div className="row">

                                    <div className="col-12 col-lg-10 mx-auto border-bottom pt-2 pb-3" >
                                        <CommonCircle />
                                        <span className="">
                                            Plant were supplied at right time <AstricSign />:
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadioPlantwere('53')} id='53' name={RadioPlantwere == 53} value="53" checked={RadioPlantwere == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadioPlantwere('54')} id="54" name={RadioPlantwere == 54} value="54" checked={RadioPlantwere == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>
                                        {

                                            RadioPlantwere == "53" ?

                                                <div className="col-6">
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2 "
                                                        name="PlantSupplied"
                                                        // placeholder="value"
                                                        value={PlantSupplied}
                                                        onChange={(e) => setPlantSupplied(e.target.value)}

                                                    />
                                                </div>
                                                :
                                                ''
                                        }
                                    </div>

                                    <div className="col-12 col-lg-10 mx-auto py-3 border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Are you aware about the replacement of the samplings under the scheme ? <AstricSign /> :
                                        </span>
                                        <br />

                                        <span>
                                            <span className="px-3 px-lg-2 ">
                                                <input type="radio" onChange={() => setSaplingSchemeIndicatorID('53')} id='53' name={SaplingSchemeIndicatorID == 53} value="53" checked={SaplingSchemeIndicatorID == 53 && "checked"} />
                                                <label for="huey">Yes</label>

                                            </span>
                                            <span>
                                                <input type="radio" onChange={() => setSaplingSchemeIndicatorID('54')} id="54" name={SaplingSchemeIndicatorID == 54} value="54" checked={SaplingSchemeIndicatorID == 54 && "checked"} />
                                                <label for="dewey">No</label>
                                            </span>

                                        </span>

                                    </div>

                                    <div className="col-12 col-lg-10 mx-auto pt-3 border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Contacted the cluster / RPS leader / Field Officer for casualty replacement <AstricSign /> :
                                        </span>
                                        <br />

                                        <span className="px-3 px-lg-2">
                                            <input type="radio" onChange={() => setCasualtyReplacementIndicatorID('53')} id='53' name={CasualtyReplacementIndicatorID == 53} value="53" checked={CasualtyReplacementIndicatorID == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setCasualtyReplacementIndicatorID('54')} id="54" name={CasualtyReplacementIndicatorID == 54} value="54" checked={CasualtyReplacementIndicatorID == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>

                                    </div>

                                    <div className="col-12 col-lg-10 mx-auto pt-3 border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Replaced the dead samplings? <AstricSign /> :
                                        </span>
                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadiodeadsamplings('53')} id='53' name={Radiodeadsamplings == 53} value="53" checked={Radiodeadsamplings == 53 && "checked"} />
                                            <label for="huey">Yes</label>
                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadiodeadsamplings('54')} id='54' name={Radiodeadsamplings == 54} value="54" checked={Radiodeadsamplings == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>

                                        {
                                            Radiodeadsamplings == 53 &&
                                            <span className=" add_button mx-3 px-3 py-1"
                                                onClick={() => handleShowDeadSamplingModal(true)}
                                            >
                                                <i class="fa-solid fa-plus"></i>  Add
                                            </span>
                                        }


                                        {
                                            isDeleteLoading ? <Loading /> :
                                                Radiodeadsamplings == 53 ?
                                                    <div className="table-responsive p-0 mt-2" >
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr className=" text-white">
                                                                    <th className="text-center">Procure the sampling from</th>
                                                                    <th className="text-center">No Of Sampling</th>
                                                                    <th className="text-center">Cover Losess</th>
                                                                    <th className="text-center">Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    ReplacedDeadSampling && ReplacedDeadSampling.length > 0 ? ReplacedDeadSampling.map((i, j) => {
                                                                        return (
                                                                            <tr>

                                                                                <td>{i.replacedDeadSaplings_M_IndicatorName ? i.replacedDeadSaplings_M_IndicatorName : '-'}</td>

                                                                                {
                                                                                    i.replacedDeadSaplings_M_IndicatorID == '58' ?
                                                                                        <>
                                                                                            <td>{i.quantity ? "Received Quantity : " : ''}{i.quantity ? i.quantity : '-'}</td>
                                                                                            <td>{i.yesNo_M_Indicator ? i.yesNo_M_Indicator : '-'} </td>
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            <td>{i.quantity ? "Purchased Quantity : " : ''}{i.quantity ? i.quantity : '-'}</td>
                                                                                            <td>{i.yesNo_M_Indicator ? i.yesNo_M_Indicator : '-'} <hr />{i.remark ? i.remark : '-'}</td>

                                                                                        </>
                                                                                }

                                                                                <td align="center">
                                                                                    {/* <i className="fa fa-edit mx-2 v_icon_style" title="Edit"
                                                                            onClick={() => {
                                                                                handleShowDeadSamplingModal(true, 'Update', i)
                                                                            }}
                                                                        ></i> */}
                                                                                    <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                                                        onClick={() => handleShowDelete(i)}
                                                                                        title="Do you want to delete this record?"></i>
                                                                                </td>

                                                                            </tr>
                                                                        )
                                                                    })
                                                                        :
                                                                        <>No data found</>
                                                                }


                                                            </tbody>
                                                        </table>

                                                    </div>
                                                    :
                                                    <></>
                                        }



                                    </div>


                                    <div className="col-12 col-lg-10 mx-auto pt-3 pb-2 border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Reason for death <AstricSign /> :
                                        </span>


                                        <div className="row">
                                            {
                                                DeathData && DeathData.length > 0 && DeathData.map((i, j) =>
                                                    <div className="col-12 pt-3">
                                                        <form >
                                                            <input type="checkbox"
                                                                className="px-3"
                                                                id={i.reasonForDeathM_IndicatorID}
                                                                name={i.reasonForDeathM_IndicatorID}
                                                                checked={i.isChecked}
                                                                value={i.reasonForDeathM_IndicatorID}
                                                                onChange={() => handleRadioValueChange(1, j)}
                                                            />
                                                            <span for="Weather" className="ps-2">{i.t_BeneficiaryPlantationDetails_ReasonForDeath}</span>
                                                        </form>
                                                    </div>
                                                )}

                                        </div>
                                    </div>

                                    {/* ---------------------Keeping plants at home------------------- */}

                                    <KeepingPlantsAtHome
                                        RadioKeepingplants={RadioKeepingplants}
                                        setRadioKeepingplants={setRadioKeepingplants}
                                        M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                        KeepingQualityHomeData={KeepingQualityHomeData}
                                        DataIsPost={DataIsPost}
                                        setDataIsPost={setDataIsPost}
                                        YearValue={YearValue}
                                        MonthValue={MonthValue}

                                    />

                                    <div className="col-12 col-lg-10 mx-auto pt-3 border-bottom">
                                        {/* <span className="fw-bold ">Quality and status of plantation:</span> */}

                                        <div className="row">
                                            <div className="col-12 col-lg-8">
                                                <CommanPlantionDetailsPartTwoDDL
                                                    QualityStatusId={QualityStatusId}
                                                    setQualityStatusId={setQualityStatusId}
                                                    apiFlag='QualityAndStatus'
                                                    Flag={flag}
                                                    data={PlantationDetails && PlantationDetails[0]}
                                                    IsPost=''
                                                    AstricSignFlag="AstricSign"
                                                // PlantationDetails={PlantationDetails}
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-10 pt-4 pb-3 mx-auto border-bottom">
                                        <CommonCircle />
                                        <span className="">Quality of planting material <AstricSign /> : </span>

                                        <div className="row">
                                            <div className="col-12 col-lg-8">
                                                <div className="form-group m-0 pt-3">
                                                    <span className="text-dark fw-bold ">One step <AstricSign /> : </span>
                                                    <small className="text-dark">(% of total planting material with one step)</small>
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        name="OneStep"
                                                        placeholder="One step"
                                                        value={OneStep}
                                                        onChange={(e) => setOneStep(e.target.value)}

                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-8">
                                                <div className="form-group m-0 pt-3">
                                                    <span className="text-dark fw-bold ">Two step <AstricSign /> : </span>
                                                    <small className="text-dark">(% of total planting material with three step)</small>
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        name="TwoStep"
                                                        placeholder="Two step"
                                                        value={TwoStep}
                                                        onChange={(e) => setTwoStep(e.target.value)}

                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-8">
                                                <div className="form-group m-0 pt-3">
                                                    <span className="text-dark fw-bold ">Three step <AstricSign /> : </span>
                                                    <small className="text-dark">(% of total planting material with two step)</small>
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        name="DepartmentName"
                                                        placeholder="Three step"
                                                        value={ThreeStep}
                                                        onChange={(e) => setThreeStep(e.target.value)}

                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="col-12 pt-5 ">
                                        <div className="form-group w-80 d-flex justify-content-center">
                                            <button
                                                type='button'
                                                onClick={() => handleUpdate()}
                                                disabled={RadioPlantwere == '' || PlantSupplied == "" || SaplingSchemeIndicatorID == '' || CasualtyReplacementIndicatorID == '' ||
                                                    Radiodeadsamplings == '' || RadioKeepingplants == '' || QualityStatusId.ID == 0
                                                }
                                                className="btn bg-success text-white border-2 mx-2 px-4" data-ktwizard-type="action-next">
                                                Update
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => handleShowAddModal(false, '')}
                                                className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div >
            }

            {
                ShowDeadSamplingModal.showHide &&
                <ReplacedDeadSamplingsPopUp
                    handleShowDeadSamplingModal={handleShowDeadSamplingModal}
                    Radiodeadsamplings={Radiodeadsamplings}
                    setRadiodeadsamplings={setRadiodeadsamplings}
                    ReplacedDeadSamplingsId={ReplacedDeadSamplingsId}
                    setReplacedDeadSamplingsId={setReplacedDeadSamplingsId}
                    Radiocoverlosses={Radiocoverlosses}
                    setRadiocoverlosses={setRadiocoverlosses}
                    Title='Replaced the dead samplings'
                    ShowDeadSamplingModal={ShowDeadSamplingModal}
                    M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                    handleIsReplacedDeadSamplingData={handleIsReplacedDeadSamplingData}
                    YearValue={YearValue}
                    MonthValue={MonthValue}

                />
            }
            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}

                    /> : <></>
            }


        </>);
}

export default PartSecondPopup;